import { forwardRef, useImperativeHandle, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";

const CaptchaSection = forwardRef(({ onVerify }, parentRef) => {
    const recaptchaRef = useRef(null);

    const handleChange = (token) => {
        onVerify(token || "");
    };

    const handleExpired = () => {
        onVerify("");
    };

    // Expose reset method to parent component
    useImperativeHandle(parentRef, () => ({
        reset: () => {
            if (recaptchaRef.current) {
                recaptchaRef.current.reset();
            }
        }
    }));
    console.log("reCAPTCHA Key:", process.env.REACT_APP_RECAPTCHA_SITE_KEY);
    return (
        <div className="mt-3">
            <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                onChange={handleChange}
                onExpired={handleExpired}
            />
        </div>
    );
});

CaptchaSection.displayName = "CaptchaSection";

export default CaptchaSection;
